import React, { useState } from "react";
import "./App.css";
import { Navigation } from "./navigation";
import { checkConsentCookie, round } from "./common/utils/functions";
import { useEffect } from "react";
import { Header } from "./common/components/Header";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useTranslation } from "react-i18next";

const App = () => {
  const [hasCookie, setHasCookie] = useState(checkConsentCookie());
  const [openCookiebar, setOpenCookiebar] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("info");
  const { t, i18n } = useTranslation();
  const [lng, setLng] = useState("");

  useEffect(() => {
    setOpenCookiebar(!hasCookie);
  }, []);

  useEffect(() => {
    const c = document.cookie.split("; ");
    const language = c.filter((item) => {
      return item.includes("LANG");
    });
    if (language.length > 0) {
      const lang = language[0].split("=")[1];
      i18n.changeLanguage(lang);
      setLng(lang);
    } else {
      i18n.changeLanguage("sv-SE");
      setLng("sv-SE");
    }
  }, []);

  const handleCloseCookiebar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenCookiebar(false);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleOpenSnackbar = (severity, message) => {
    setSnackbarType(severity);
    setSnackbarMessage(message);
    setOpenSnackbar(true);
  };

  return (
    <div className="App">
      <div className="content">
        <Header lng={lng} setLng={setLng} />
        <Navigation handleOpenSnackbar={handleOpenSnackbar} lng={lng} setLng={setLng} />
        <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity={snackbarType} sx={{ width: "100%" }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
        <Snackbar
          open={openCookiebar}
          onClose={handleCloseCookiebar}
          message={t("cookie_banner")}
          action={
            <Button
              color="primary"
              size="small"
              onClick={(event, reason) => {
                const expires = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
                document.cookie = `CONSENT=true; expires=${expires}`;
                setHasCookie(true);
                handleCloseCookiebar(event, reason);
              }}
              style={{ color: "yellow" }}
            >
              {t("ok")}
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default App;
